import { inject, Injectable } from "@angular/core";
import { User } from "../models/user";
import { DatePipe } from "@angular/common";
import { addDays, addMonths, endOfMonth, startOfMonth, startOfWeek } from "date-fns";
import { SubmissionDateRangePreset, UIPreference } from "../models/ui-preferences";
import { Params } from "@angular/router";

@Injectable()
export class DefaultQueries {
    datepipe = inject(DatePipe)
    public compute(user: User) {
        const defaultFilters: { [key: string]: any } = {
            "submissions": { "filter.status": "submitted", "filter.reportsto.hawkid": null, "filter.start": null, "filter.end": null },
            "users": { "filter.reportsto.hawkid": null }
        };
        const uiPreference = user.userUIPreference?.data ? <UIPreference>JSON.parse(user.userUIPreference.data) : new UIPreference();
        defaultFilters["users"]["filter.reportsto.hawkid"] = user.hawkId;
        const userDefaultSubm = uiPreference.submissions?.savedQueryStrings.find(s => s[0] === 'Default');
        if (userDefaultSubm && userDefaultSubm[1] instanceof Object) {
            const params = userDefaultSubm[1] as Params;
            const subm = <{[key: string]: any}>{};
            for(let k in params) {
                subm[k] = params[k];
            }
            defaultFilters["submissions"] = subm;
        } else {
            defaultFilters["submissions"]["filter.reportsto.hawkid"] = user.hawkId;
            const { start, end } = this.submissionsDateRange(uiPreference.submissions?.dateRangePreset);
            defaultFilters["submissions"]["filter.start"] = this.datepipe.transform(start, "yyyy-MM-dd");
            defaultFilters["submissions"]["filter.end"] = this.datepipe.transform(end, "yyyy-MM-dd");
        }
        return defaultFilters;
    }

    public submissionsDateRange(preset: SubmissionDateRangePreset = "this-month"): { start: Date, end: Date } {
        preset = preset === <SubmissionDateRangePreset><unknown>"next-week" ? "last-week" : preset;
        const today = new Date();
        switch (preset) {
            case "this-week": {
                const start = startOfWeek(today);
                return { start, end: addDays(start, 6) };
            }
            case "last-week": {
                const start = addDays(startOfWeek(today), -7);
                return { start, end: addDays(start, 6) };
            }
            case "last-month": {
                const lastMonth = addMonths(today, -1);
                return { start: startOfMonth(lastMonth), end: endOfMonth(lastMonth) };
            }
            case "last-3-months":
                return { start: startOfMonth(addMonths(today, -2)), end: endOfMonth(today) };
            case "since-epoch":
                return { start: new Date(2025, 5, 29), end: today };
            case "this-month":
            default:
                return { start: startOfMonth(today), end: endOfMonth(today) };
        }
    }
}
